/** Intentional no-op for mockup-mode event handlers. */
export function noop() {}
